<template>
  <div class="lg:flex lg:items-center lg:justify-between">
    <div class="min-w-0 flex-1">
      <h2
        class="flex items-center gap-3 text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight dark:text-white"
      >
        Runners
        <span
          v-if="readOnly"
          class="inline-flex items-center gap-1 rounded-md bg-gray-50 px-2 py-0.5 text-xs font-medium tracking-normal text-gray-600 inset-ring inset-ring-gray-500/10 dark:bg-gray-400/10 dark:text-gray-400 dark:inset-ring-gray-400/20"
          title="Your role in this organization is Viewer."
          data-testid="view-only-badge"
        >
          <EyeIcon class="size-3.5" aria-hidden="true" />
          View only
        </span>
      </h2>
    </div>
    <div v-if="!readOnly" class="mt-5 flex lg:mt-0 lg:ml-4">
      <!--      <span class="ml-3 hidden sm:block">-->
      <!--        <button type="button" class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">-->
      <!--          <LinkIcon class="mr-1.5 -ml-0.5 size-5 text-gray-400 dark:text-white" aria-hidden="true" />-->
      <!--          View-->
      <!--        </button>-->
      <!--      </span>-->

      <span class="sm:ml-3">
        <span
          v-if="planRequired"
          role="link"
          aria-disabled="true"
          title="This needs an active plan."
          class="inline-flex cursor-not-allowed items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 opacity-50 shadow-xs inset-ring inset-ring-gray-300 dark:bg-white/10 dark:text-white dark:inset-ring-white/5"
        >
          <ServerStackIcon class="mr-1.5 -ml-0.5 size-5 text-gray-400" aria-hidden="true" />
          Add external runner
        </span>
        <RouterLink
          v-else
          :to="{ name: 'CreateExternalRunner' }"
          title="Show a self-hosted GitLab or GitHub runner server on the dashboard"
          class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20"
          data-testid="add-external-runner"
        >
          <ServerStackIcon
            class="mr-1.5 -ml-0.5 size-5 text-gray-400 dark:text-white"
            aria-hidden="true"
          />
          Add external runner
        </RouterLink>
      </span>

      <span class="ml-3">
        <span
          v-if="planRequired"
          role="link"
          aria-disabled="true"
          title="This needs an active plan."
          class="inline-flex cursor-not-allowed items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white opacity-50 shadow-xs dark:bg-indigo-500 dark:shadow-none"
          data-testid="create-runner-disabled"
        >
          <PlusIcon class="mr-1.5 -ml-0.5 size-5" aria-hidden="true" />
          Create Runner
        </span>
        <RouterLink
          v-else
          :to="{ name: 'CreateRunner' }"
          class="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 dark:bg-indigo-500 dark:shadow-none dark:hover:bg-indigo-400 dark:focus-visible:outline-indigo-500"
        >
          <PlusIcon class="mr-1.5 -ml-0.5 size-5" aria-hidden="true" />
          Create Runner
        </RouterLink>
      </span>

      <!--      &lt;!&ndash; Dropdown &ndash;&gt;-->
      <!--      <Menu as="div" class="relative ml-3 sm:hidden">-->
      <!--        <MenuButton class="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 dark:bg-white/10 dark:text-white dark:shadow-none dark:inset-ring-white/5 dark:hover:bg-white/20">-->
      <!--          More-->
      <!--          <ChevronDownIcon class="-mr-1 ml-1.5 size-5 text-gray-400 dark:text-white" aria-hidden="true" />-->
      <!--        </MenuButton>-->

      <!--        <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform scale-100" leave-to-class="transform opacity-0 scale-95">-->
      <!--          <MenuItems class="absolute left-0 z-10 mt-2 -mr-1 w-24 origin-top-right rounded-md bg-white py-1 shadow-lg outline outline-black/5 dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">-->
      <!--&lt;!&ndash;            <MenuItem v-slot="{ active }">&ndash;&gt;-->
      <!--&lt;!&ndash;              <a href="#" :class="[active ? 'bg-gray-100 outline-hidden dark:bg-white/5' : '', 'block px-4 py-2 text-sm text-gray-700 dark:text-gray-300']">View</a>&ndash;&gt;-->
      <!--&lt;!&ndash;            </MenuItem>&ndash;&gt;-->
      <!--          </MenuItems>-->
      <!--        </transition>-->
      <!--      </Menu>-->
    </div>
  </div>
</template>

<script setup lang="ts">
import { EyeIcon, PlusIcon, ServerStackIcon } from '@heroicons/vue/20/solid';

defineProps({
  // Viewers can't create runners.
  readOnly: { type: Boolean, default: false },
  planRequired: { type: Boolean, default: false },
});
</script>
